/**
 * @generated SignedSource<<f6b28c23da4421c3f9de7db54a2d2bb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "legalContractId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tin"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BillingGroupMutationGroup",
    "kind": "LinkedField",
    "name": "billingGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "legalContractId",
                "variableName": "legalContractId"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              },
              {
                "kind": "Variable",
                "name": "tin",
                "variableName": "tin"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "BillingGroupModifyPayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingGroup",
            "kind": "LinkedField",
            "name": "billingGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewBillingGroupModalMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewBillingGroupModalMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "06983f3d0c52d8d6f0afaeec5b1d9d20",
    "id": null,
    "metadata": {},
    "name": "NewBillingGroupModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewBillingGroupModalMutation(\n  $name: String!\n  $legalContractId: ID!\n  $tin: String!\n) {\n  billingGroup {\n    create(input: {name: $name, legalContractId: $legalContractId, tin: $tin}) {\n      billingGroup {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "22534d7c5ac01446f4bda90cf7d353e5";

export default node;
